import React from 'react';
import { View, StyleSheet, Dimensions, Platform } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';

const { height } = Dimensions.get('window');

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.CONTAINER_MARGIN,
    height: height / 6,
    ...Platform.select({
      web: {
        height: 'auto,',
        paddingTop: 10,
        paddingBottom: 10,
      },
    }),
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: height > 600 ? theme.FONT_SIZE_HEADLINE * 2.5 : theme.FONT_SIZE_HEADLINE * 2,
    fontFamily: 'Pacifico',
  },
});

export default function InboxHeader() {
  return (
    <View style={styles.header}>
      <CustomText style={styles.headerText}>Turtlets</CustomText>
    </View>
  );
}
